var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5865 1.00002L11.0008 0.414276C10.838 0.251557 10.5742 0.251557 10.4115 0.414276L6.00076 4.82499L1.59001 0.414275C1.42729 0.251557 1.16347 0.251557 1.00076 0.414275L0.415012 1.00002C0.252293 1.16274 0.252293 1.42656 0.415012 1.58928L4.82576 5.99999L0.415016 10.4108C0.252298 10.5735 0.252298 10.8373 0.415016 11L1.00076 11.5858C1.16348 11.7485 1.4273 11.7485 1.59002 11.5858L6.00076 7.17499L10.4115 11.5857C10.5742 11.7485 10.838 11.7485 11.0008 11.5857L11.5865 11C11.7492 10.8373 11.7492 10.5735 11.5865 10.4107L7.17575 5.99999L11.5865 1.58928C11.7492 1.42656 11.7492 1.16274 11.5865 1.00002Z",
    fill: "#567AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMark);
export default __webpack_public_path__ + "static/media/closeMark.2186f196.svg";
export { ForwardRef as ReactComponent };